import { StoreLista } from './Lista'

export default new StoreLista({
    tipo: 'fisica',
    nombre: null,
    apellido: null,
    dni: null,
    cuit: null
});


// WEBPACK FOOTER //
// ./src/stores/listados/Personas.js